import { Navigate, useLocation } from "react-router-dom";

export const RemoveTrailingSlash = () => {
  const location = useLocation();

  // If the last character of the url is '/' then redirect to new path without trailing slash
  if (location.pathname.match("/.*/$")) {
    return (
      <Navigate
        replace
        to={{
          pathname: location.pathname.replace(/\/+$/, ""),
          search: location.search,
        }}
      />
    );
  } else return null;
};
